import {
  ACCOUNT_CHANGE_NOTIFICATION,
  ACCOUNT_CURRENT,
  ACCOUNT_LOGIN_EXTERNAL_USER,
  ACCOUNT_LOGIN_STUDENT,
  ACCOUNT_LOGIN_USER,
  ACCOUNT_SIGN_OUT,
  ACCOUNT_UPDATE,
  ALL_ROLES_ENDPOINT,
  UPDATE_ROLES_ENDPOINT,
} from "../Constants/Endpoints";
import { apiCallJson } from "../Helpers";

export async function getCurrentUserParams() {
  return await apiCallJson(ACCOUNT_CURRENT, "GET", null);
}

export async function loginStudent(barcode, postalcode) {
  return await apiCallJson(ACCOUNT_LOGIN_STUDENT, "POST", {
    barcode: barcode.toLowerCase().replace("if", ""),
    postalCode: postalcode,
  });
}

export async function loginUser(email, password) {
  return await apiCallJson(ACCOUNT_LOGIN_USER, "POST", {
    email: email,
    password: password,
  });
}

export async function signOut() {
  return await apiCallJson(ACCOUNT_SIGN_OUT, "POST");
}

export async function loginExternalUser(query) {
  return await apiCallJson(ACCOUNT_LOGIN_EXTERNAL_USER + query, "POST");
}

export async function getAllUsersAsync(
  pageNumber,
  recordsPerPage,
  roleName,
  propSort,
  descending,
  filter
) {
  let filterQuery = "";
  if (filter) {
    filter.forEach((element) => {
      if (element.value) {
        filterQuery += "&" + element.key + "=" + element.value;
      }
    });
  }

  let sortQuery = "";
  if (propSort) {
    sortQuery = "&sortProp=" + propSort + "&descending=" + descending;
  }

  return await apiCallJson(
    "/Account/all/" +
    roleName +
    "?pageNumber=" +
    pageNumber +
    "&recordsPerPage=" +
    recordsPerPage +
    sortQuery +
    filterQuery,
    "GET",
    null
  );
}

export async function updateUserSoftEmail(softEmail) {
  return await apiCallJson("/Account/current/softemail", "PUT", {
    softEmail: softEmail,
  });
}

export async function updateUserEmail(email) {
  return await apiCallJson("/Account/current/email", "PUT", {
    email: email,
  });
}

export async function updatePassword(oldPass, newPass, newRepeatedPass) {
  return await apiCallJson("/Account/changepassword", "PUT", {
    OldPassword: oldPass,
    NewPassword: newPass,
    ConfirmNewPassword: newRepeatedPass,
  });
}

export async function getAllRolesRequest() {
  return await apiCallJson(ALL_ROLES_ENDPOINT, "GET");
}

export async function putUserRolesRequest(userId, body) {
  return await apiCallJson(
    UPDATE_ROLES_ENDPOINT + "?userId=" + userId,
    "PUT",
    body
  );
}

export async function putAccount(body) {
  return await apiCallJson(ACCOUNT_UPDATE, "PUT", body);
}

/**
 * @async
 * @function updateAccountNotification
 * @param {boolean} showAdvice
 * @returns {Promise<any>}
 */
export async function updateAccountNotification(showAdvice) {
  return await apiCallJson(`${ACCOUNT_CHANGE_NOTIFICATION}?showAdvice=${showAdvice}`, "PUT");
}